import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import NavbarLogin from "./navbar/navbar-login.js"
import NavbarProfile from "./navbar/navbar-profile.js"
import NavbarItem from "./navbar/navbar-item.js"

const StyledNav = styled.nav`
  width: 100%;
  min-width: max-content;

  @media (max-width: 1200px) {
    width: max-content;
  }
  display: flex;
  justify-content: flex-end;
  gap: 32px;
  @media (max-width: 900px) {
    display: none;
  }
`

const NavPrimary = ({
  items,
  setUserFlowMode,
  setShowUserModal,
  user,
  signout,
}) => {
  const [showPopup, setShowpopup] = useState(-1)

  return (
    <StyledNav id="navigation">
      {items.map((item, index) => {
        return (
          <NavbarItem
            key={item.name}
            name={item.name}
            items={item.items}
            index={index}
            header={item?.spread?.header}
            showPopup={showPopup}
            setShowpopup={setShowpopup}
          />
        )
      })}

      {!user && (
        <NavbarLogin
          setUserFlowMode={setUserFlowMode}
          setShowUserModal={setShowUserModal}
        />
      )}

      {user && (
        <NavbarProfile
          user={user}
          signout={signout}
          showPopup={showPopup}
          setShowpopup={setShowpopup}
        />
      )}
    </StyledNav>
  )
}
NavPrimary.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  setUserFlowMode: PropTypes.func.isRequired,
  setShowUserModal: PropTypes.func.isRequired,
  user: PropTypes.object,
  signout: PropTypes.func.isRequired,
}

export default NavPrimary
